import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { TextAreaWrapper, SectionWrapper } from './TextArea.style';

class TextArea extends Component {
  constructor(props) {
    super(props);
    this.state = {
      text: '',
    };
    this.onTextInput = this.onTextInput.bind(this);
  }

  onTextInput(evt) {
    this.setState(
      {
        text: evt.target.value,
      },
      () => {
        this.props.handleTextAreaInput(this.props.id, this.state.text);
      },
    );
  }

  render() {
    const { length, showCount } = this.props;
    return (
      <SectionWrapper>
        <TextAreaWrapper
          aria-label='High Five Details'
          onChange={this.onTextInput}
          value={this.state.text}
          placeholder="Provide detail here ..."
          type="text"
          maxLength={length}
        />
        {showCount ? (
          <p>
            {this.state.text.length}/{length}
          </p>
        ) : null}
      </SectionWrapper>
    );
  }
}

TextArea.propTypes = {
  handleTextAreaInput: PropTypes.func.isRequired,
  id: PropTypes.string,
  length: PropTypes.number,
  showCount: PropTypes.bool,
};

TextArea.defaultProps = {
  length: 1000,
  showCount: true,
};

export default TextArea;



// WEBPACK FOOTER //
// ./src/components/TextArea/TextArea.js